import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Converte para maiúsculas o que for digitado ou colado no campo.
 *
 * <p>Ao contrário de `appLicensePlate`, não remove caracteres nem trunca o valor:
 * a validação do campo é que deve reprovar a entrada inválida (PBI 112201).
 * Como o comprimento não muda, a posição do cursor é preservada.</p>
 */
@Directive({
  selector: '[appUppercase]',
})
export class UppercaseDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() private control: NgControl,
  ) {}

  @HostListener('input')
  onInput(): void {
    const input = this.el.nativeElement;
    const upperCased = input.value.toUpperCase();

    if (upperCased === input.value) {
      return;
    }

    const selectionStart = input.selectionStart;
    const selectionEnd = input.selectionEnd;

    input.value = upperCased;
    this.control?.control?.setValue(upperCased, { emitEvent: false });

    if (selectionStart !== null && selectionEnd !== null) {
      input.setSelectionRange(selectionStart, selectionEnd);
    }
  }
}
